/**
 * ชนิดข้อมูลของหน้าจอจัดการ SSO — ตาม `apps/api/.../sso/admin_schemas.py`
 * และ `docs/API_CONTRACT.md` (`/v1/admin`, D-175)
 */

export const SSO_ADMIN_MODULE = 'RBAC_ADMIN';

/** `details.rule` ที่เซิร์ฟเวอร์ตอบจริงจาก `admin_service.py` */
export const SSO_RULES = {
  REDIRECT_URI_INVALID: 'REDIRECT_URI_INVALID',
  REDIRECT_URI_SCHEME: 'REDIRECT_URI_SCHEME',
  REDIRECT_URI_UNSAFE_CHARACTER: 'REDIRECT_URI_UNSAFE_CHARACTER',
  REDIRECT_URI_DOMAIN_NOT_ALLOWED: 'REDIRECT_URI_DOMAIN_NOT_ALLOWED',
  REDIRECT_URI_LOOPBACK_NOT_ALLOWED: 'REDIRECT_URI_LOOPBACK_NOT_ALLOWED',
  REDIRECT_URI_KIND_OVERLAP: 'REDIRECT_URI_KIND_OVERLAP',
  APP_ROLE_NOT_FOUND: 'APP_ROLE_NOT_FOUND',
  APP_NOT_FOUND: 'APP_NOT_FOUND',
  APP_CODE_TAKEN: 'APP_CODE_TAKEN',
  APP_ROLE_TAKEN: 'APP_ROLE_TAKEN',
  APP_ROLE_DUPLICATE: 'APP_ROLE_DUPLICATE',
  CLIENT_ID_TAKEN: 'CLIENT_ID_TAKEN',
  CLIENT_NOT_FOUND: 'CLIENT_NOT_FOUND',
  EMPLOYEE_NOT_FOUND: 'EMPLOYEE_NOT_FOUND',
  APP_ROLE_NOT_HELD: 'APP_ROLE_NOT_HELD',
  CONCURRENT_CHANGE: 'CONCURRENT_CHANGE',
} as const;

export interface SsoAppRole {
  readonly role_code: string;
  readonly description: string;
  readonly active: boolean;
}

export interface SsoApp {
  readonly app_code: string;
  readonly app_name: string;
  readonly active: boolean;
  readonly roles: readonly SsoAppRole[];
}

export interface SsoOauthClient {
  readonly client_id: string;
  readonly app_code: string;
  readonly client_name: string;
  readonly redirect_uris: readonly string[];
  readonly post_logout_redirect_uris: readonly string[];
  readonly mfa_roles: readonly string[];
  readonly refresh_enabled: boolean;
  readonly allow_insecure_localhost: boolean;
  readonly require_app_role: boolean;
  readonly require_nonce: boolean;
  readonly active: boolean;
  readonly secret_rotated_at: string | null;
  readonly created_by_employee_id: string;
  readonly created_at: string;
}

/** คำตอบของ create/rotate — `client_secret` แสดงครั้งเดียว ห้ามเก็บต่อ */
export interface SsoIssuedClient {
  readonly client: SsoOauthClient;
  readonly clientSecret: string;
}

export interface SsoAppRoleAssignment {
  readonly employee_id: string;
  readonly display_name: string | null;
  readonly app_code: string;
  readonly role_code: string;
  readonly granted_by_employee_id: string;
  readonly granted_at: string;
  readonly self_granted: boolean;
}

export interface CreateSsoAppBody {
  readonly app_code: string;
  readonly app_name: string;
  readonly roles: readonly { readonly role_code: string; readonly description: string }[];
}

export interface AddSsoAppRoleBody {
  readonly role_code: string;
  readonly description: string;
}

export interface CreateSsoClientBody {
  readonly client_id: string;
  readonly app_code: string;
  readonly client_name: string;
  readonly redirect_uris: readonly string[];
  readonly post_logout_redirect_uris: readonly string[];
  readonly mfa_roles: readonly string[];
  readonly refresh_enabled: boolean;
  readonly allow_insecure_localhost: boolean;
}

export interface UpdateSsoClientBody {
  readonly client_name?: string;
  readonly redirect_uris?: readonly string[];
  readonly post_logout_redirect_uris?: readonly string[];
  readonly mfa_roles?: readonly string[];
  readonly refresh_enabled?: boolean;
  readonly allow_insecure_localhost?: boolean;
  readonly require_app_role?: boolean;
  readonly active?: boolean;
}
